<!-- 宣告表 /审核 sqm -->
<template>
  <ComponentDeclarationForm :kindType="data.kindType" :getData="data.getData" v-if="data.getData.supplyCode" @auditBtn="submit" @backBtn="routerBack"
    :auditLoading="data.auditLoading"></ComponentDeclarationForm>
    <div v-else style="width:100%; height: 600px;" v-loading="data.pageLoading"></div>
</template>

<script setup>
//Automatic script writing.
import h_i18n from '@/utils/Internationalization';

  import { reactive, getCurrentInstance, onMounted, onUpdated, nextTick, onBeforeMount, onActivated, onDeactivated, onUnmounted } from "vue";
  import { useRoute } from "vue-router";
  import axios from "axios";
  import ComponentDeclarationForm from "../ComponentDeclarationForm"
  const { proxy, ctx } = getCurrentInstance()
  const route = useRoute()

  const data = reactive({
    kindType:'sqmAudit',
    getData:{},
    auditLoading:false,
    auditTwoDate:'',
    pageLoading:false,
  })
  const routerBack = () => {
    proxy.$router.back()
  }
  const submit = (val) => {
    console.log(val)
    data.auditLoading = true
    proxy.$http({
      url:'/base/newrohs/saveAuditFromZLBZ',
      method:'post',
      data:{
        // ...val,
        fixConfig:true,
        auditTwoName:data.trueName,
        auditTwoDate:data.auditTwoDate,
        auditTwoStatus:val.auditTwoStatus,
        auditTwoMark:val.auditTwoMark,
        id:data.id
      }
    }).then((res=>{
      if(res.data.code == '0' && res.data.data == 'success'){
        proxy.success({
          message: h_i18n('4638a6dc77e085601e70f2c750244fb3'),
          title: h_i18n('330363dfc524cff2488f2ebde0500896'),
          confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
          callback: (action) => {
            routerBack()
          }
        });
      }else{
        proxy.info(res.data.msg || h_i18n('1f0729004026b5d3963e8f78b6d2d85e'))
      }
    })).catch(err=>{

    }).finally(()=>{
      data.auditLoading = false
    })
  }
  const getInfo = () => {
    data.pageLoading = true
    proxy.$http({
      url:'/base/newrohs/getMainInfo?id='+data.id,
      method:'get',
    }).then((res=>{
      data.getData.dataOfTable = res.data.data.detailList
      data.getData.basalInfo = res.data.data.roHSMainDTO
    })).catch(err=>{

    }).finally(()=>{
      // 审核数据 列表化
      let tem = data.getData.basalInfo
      
      data.auditTwoDate = proxy.time(new Date(),6)
      data.getData.auditData = [
        {role:h_i18n('5200ed8b578c7b02a035f9b7424830d5'),name:tem.savePerson,time:tem.saveTime,result:'',opinion:''},
        {role:h_i18n('43e33e242b484dc4633ff7d6519c307d'),name:data.trueName,time:data.auditTwoDate,result:tem.auditTwoStatus,opinion:tem.auditTwoMark},
        {role:h_i18n('7d0d9d5a6a61aa1f3037e2514fe3a18d'),name:tem.checkPerson,time:tem.checkTime,result:tem.checkStatus,opinion:tem.checkMark},
      ]
      data.getData.supplyCode = route.query.supplyCode ?  route.query.supplyCode : ''
      data.getData.supplyName = route.query.supplyName ?  route.query.supplyName : ''     
      data.pageLoading = false 
    })
  }


  onBeforeMount(()=>{
    if (route.query) {
      // data.supplyCode = route.query.supplyCode ?  route.query.supplyCode : ''
      // data.supplyName = route.query.supplyName ?  route.query.supplyName : ''
      data.kindType = route.query.kindType ? route.query.kindType : 'sqmAudit'
      data.conformityDeclarationsId = route.query.conformityDeclarationsId ?  route.query.conformityDeclarationsId : undefined
      data.sourceId = route.query.sourceId ?  route.query.sourceId : undefined
      data.userName = route.query.userName ?  route.query.userName : ''
      data.trueName = route.query.trueName ?  route.query.trueName : ''
      data.getData.userName = route.query.userName ?  route.query.userName : ''
      data.getData.trueName = route.query.trueName ?  route.query.trueName : ''
      data.getData.roleCode = route.query.roleCode ?  route.query.roleCode : undefined
      data.id = route.query.id ?  route.query.id : ''
    }    
  })

  onMounted(() => {
    if(route.query.dataFrom != 'sqm'){
      proxy.$router.replace('/404')
      return
    }
    if(!route.query.supplyCode || !route.query.supplyName || !route.query.trueName){
      proxy.info({title: h_i18n('02d9819ddaaaeb1b7b22b12608c7e5ca'), message: h_i18n('c0f92e28b64a4268408f10aa60dc47c8'),confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
        callback: (action) => {
          routerBack()
        },})
      return
    }
    getInfo()
    for(let i = 1 ; i < 10; i++){
      setTimeout(() => {
        proxy.postThisPageHeightMore()
      }, i*100);
    }
  })
</script>

<style>

</style>